import { render, staticRenderFns } from "./locatorTask.vue?vue&type=template&id=a58c0634&scoped=true&"
import script from "./locatorTask.vue?vue&type=script&lang=js&"
export * from "./locatorTask.vue?vue&type=script&lang=js&"
import style0 from "./locatorTask.vue?vue&type=style&index=0&id=a58c0634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58c0634",
  null
  
)

export default component.exports